<form [formGroup]="form"
      (ngSubmit)="submit()"
      class="dynamic-form">

  <ng-container *ngFor="let field of formFields" class="form-row">
    <app-dynamic-field [field]="field" [form]="form" class="dynamic-form__field"></app-dynamic-field>
  </ng-container>

</form>
